import { createFileRoute } from '@tanstack/react-router';

import { CitationCreate } from '@/module/Author/Citation/CitationCreate';

export const Route = createFileRoute(
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  const { proceedingId } = Route.useParams();

  return <CitationCreate publicationId={Number(proceedingId)} />;
}
